！/**
* @Description: 选课中心
* @author Wangshu
* @date 2020/2/25
*/
<template>
    <div class="wrap td-fc td-f1" ref="warpDom">
        <div class="content-top td-fbc">
            <div class="title-box td-fcc">
                <img :src="GLOBAL.Images.dialog_book_o">
                <span>选课中心</span>
            </div>
            <div class="search-input">
                <el-input v-model="searchModel.name" placeholder="请输入课程名称"></el-input>
                <div style="width: 20px;"></div>
                <el-button type="primary" @click="selectCourse(selectName)">找课程</el-button>
            </div>
        </div>
        <div class="content-box td-f1 td-fc">
            <!-- 课程分类-->
            <div class="classify">
                <div :class="{active: searchModel.category_id == item.id}" v-for="(item,index) in categoryList"
                     :key="index" @click="selectTypeClass(item)">
                    {{item.name}}
                </div>
            </div>
            <!--教材版本-->
            <div class="book-box td-f1 td-f">
                <div class="left-list td-fc" :style="{height:contentHeight+'px'}">
                    <div class="title td-fsc">教材版本</div>
                    <div class="versions-list td-f1">
                        <div :class="{'active-item':searchModel.edition_id == item.id}"
                             v-for="(item,index) in editionList" :key="index" @click="selectTeaching(item)">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <!--课程列表-->
                <div class="right-list td-fc" v-loading="loading" :style="{height:contentHeight+'px'}">
                    <el-row class="td-f1 boox-list">
                        <el-col :lg="6" :md="6" :sm="8" :xs="8" v-for="(item,index) in courseData" :key="index">
                            <div class="book-item">
                                <div :style="{backgroundImage: 'url('+ GLOBAL.Images.img_book +')'}">{{item.name}}</div>
                                <div class="foot-btn">
                                    <div @click="openStar">订阅</div>
                                    <div  class="red-btn" @click="tryOut(item.id)">试用</div>
                                </div>
                            </div>
                        </el-col>
                        <div class="not-data" v-show="nodata">
                            <div>暂无课程,正在努力建设中...</div>
                        </div>
                    </el-row>
                    <div class="foot-info">
                        此教材版本共<span>{{courseNum}}</span>本课程
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {wordCourseList, wordSaveCourse,wordCheckTry} from "@/api/words";
    import {grammarCourseList, grammarSaveCourse,grammarCheckTry} from "@/api/grammar";
    import {curriculum} from "@/api/soundmark";
    import Lockr from 'lockr'

    export default {
        name: "selectCourse",
        props: {
            dataSource: {}
        },
        data() {
            return {
                type: '', // 单词还是语法
                searchModel: {
                    name: '',
                    category_id: '',
                    edition_id: '',
                },
                curriculum_id: '',
                selectTypeIndex: 0,
                selectTeachingIndex: 0,
                categoryList: '', //课程分类
                editionList: '', //教材版本
                courseData: '', //课程列表
                courseNum: '', //课本数量
                typeId: '', //分类Id
                versionId: '', //版本Id
                selectName: '', //搜索课程名字
                nodata: false,
                isFirst: true,
                loading: true,
                contentHeight: 450,
                remainTryNum: '',//剩余试用次数
            };
        },
        methods: {
            //搜索选课中心
            selectCourse() {
                this.loading = true
                this.getCourse()
            },
            //切换课程分类
            selectTypeClass(item) {
                this.loading = true
                this.searchModel.category_id = item.id
                this.getEdition()
            },
            //切换教材版本
            selectTeaching(item) {
                this.loading = true
                this.searchModel.edition_id = item.id
                this.getCourse()
            },
            async getEdition() {
                let params = {
                    token: Lockr.get('token'),
                    ...this.searchModel
                }
                let requestList = this.type == 'word' ? wordCourseList : grammarCourseList
                let result = await requestList(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.editionList = result.data.edition
                    this.searchModel.edition_id = this.editionList[0].id
                    this.getCourse()
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },

            //获取课程列表
            async getCourse() {
                let params = {
                    token: Lockr.get('token'),
                    ...this.searchModel
                }
                let result = await curriculum(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.loading = false
                    if (this.isFirst) {
                        this.isFirst = false
                        this.categoryList = result.data.category
                        this.editionList = result.data.edition
                        this.tel = result.data.service_mobile
                        this.searchModel.category_id = this.categoryList[0].id
                        this.searchModel.edition_id = this.editionList[0].id
                    }
                    if (!result.data.curriculum.length) {
                        this.nodata = true
                    } else {
                        this.nodata = false
                    }
                    this.courseData = result.data.curriculum
                    this.courseNum = result.data.total_curriculum
                    // this.remainTryNum = result.data.remain_try_num
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            //试用
            async tryOut(id) {
                let type=this.type == 'word' ? 1 : 2
                let params = {
                    token: Lockr.get('token'),
                    type:type,
                }
                let queryTryNum = this.type == 'word' ? wordCheckTry : grammarCheckTry
                let result = await queryTryNum(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.remainTryNum=result.data
                    if(this.remainTryNum!=0){
                        this.curriculum_id = id
                        this.$confirm(`您还可试用${this.remainTryNum}本教材，确定试用此教程吗?`, '', {
                            // this.$confirm(`您确定试用此教程吗?`, '', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true,
                        }).then((res) => {
                            this.saveCourseFn()
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'warning'
                        });
                    }
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            async saveCourseFn () {
                let _this = this
                let params = {
                    token: Lockr.get('token'),
                    type:1,
                }
                if (this.dataSource.type == 'word') {
                    params.curriculum_id = this.curriculum_id
                } else {
                    params.grammar_curriculum_id = this.curriculum_id
                }
                let requestSave = this.type == 'word' ? wordSaveCourse : grammarSaveCourse
                let result = await requestSave(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.$emit('callback', result)
                    this.getCourse()
                    this.$message({
                        message: result.msg,
                        type: 'success',
                        onClose() {
                            if (result.msg == '试用成功') {
                                //关闭课程弹窗
                                // _this.closeCourse()
                            }
                        }
                    });
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            //订阅
            openStar() {
                this.$confirm('联系电话：400 188 1586', '请联系当地学习中心开通课程', {
                    confirmButtonText: '知道了',
                    showCancelButton: false,
                    type: 'warning',
                    center: true
                })
            },
            //关闭弹窗
            closeCourse() {
                this.$parent.close()
            },
        },
        mounted() {
            setTimeout(() => {
                this.contentHeight = this.$refs.warpDom.clientHeight - 130
            }, 20)
            window.onresize = () => {
                this.contentHeight = this.$refs.warpDom.clientHeight - 130
            }
        },
        created() {
            this.type = this.dataSource.type
            this.getCourse()
        },
    }
</script>

<style scoped lang='less'>
    .wrap {
        position: relative;
    }

    .content-top {
        padding-bottom: 20px;
        padding-top: 20px;
        padding-left: 20px;
        border-bottom: solid #dbdbdb 1px;

        .title-box {
            background: #FD682A;
            padding: 8px 10px;
            border-radius: 4px;
            color: #fff;

            span {
                font-size: 17px;
            }

            img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }

        .search-input {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 40px;

            /deep/ .el-input__inner {
                border-radius: 2px;
                width: 360px;
            }

            /deep/ .el-button {
                border-radius: 2px;
            }
        }
    }

    .btn1 {
        position: absolute;
        top: -1.25rem;
        right: -1.25rem;
        padding: 0;
        border: none;
        outline: 0;
        background: 0 0;
        font-size: 1.33333rem;
        cursor: pointer;
        width: 38px;
        height: 38px;
        background: #fff;
        border-radius: 50%;
        transition: all .2s;

        img {
            width: 38px;
            height: 38px;
        }
    }

    .btn1:hover {
        transform: scale(1.1);
    }

    .left-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div:nth-of-type(1) {
            display: flex;
            align-items: center;

            p {
                font-size: 18px;
            }

            img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }
    }

    .content-box {
        transition: all .5s;
        position: relative;

        .classify {
            display: flex;
            flex-wrap: wrap;
            padding: 10px 10px 0 10px;

            > div {
                position: relative;
                font-size: 16px;
                padding: 6px 10px;
                transition: all .3s;
                border-radius: 4px;
                cursor: pointer;
                font-weight: 600;
                margin-right: 10px;
                color: #333;
            }

            > div::after {
                content: '';
                display: block;
                height: 60%;
                width: 2px;
                background-color: #aaa;
                position: absolute;
                top: 20%;
                right: -6px;
            }

            > div:hover {
                background: #416489;
                color: #fff;
            }

            > div.active {
                color: #fff;
                background: #416489;
            }
        }

        .book-box {
            /*margin-top: 20px;*/
            display: flex;

            .left-list {
                width: 350px;
                height: 430px;
                background: #fff;
                border: 1px solid #dcdcdc;

                .title {
                    height: 40px;
                    color: #333;
                    font-size: 18px;
                    font-weight: bold;
                    padding-left: 15px;
                    border-bottom: 1px solid #dcdcdc;
                }

                .versions-list {
                    padding: 0 15px;
                    overflow-y: scroll;

                    > div {
                        cursor: pointer;
                        padding: 10px 0;
                        font-size: 16px;
                        border-bottom: 1px dashed #e4e4e4;
                    }

                    > div:hover {
                        color: #00BFCC;
                    }
                }

                .active-item {
                    color: #00BFCC;
                }
            }

            .right-list {
                width: 100%;
                height: 430px;
                margin-left: 20px;

                .boox-list {
                    overflow-y: auto;
                }

                .book-item {
                    max-width: 120px;
                    margin: 10px auto;

                    > div:nth-of-type(1) {
                        height: 140px;
                        padding: 30px 15px 0px 20px;
                        font-weight: bold;
                        color: #fff;
                        font-size: 15px;
                        text-align: center;
                        transition: all .3s;
                        cursor: pointer;
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                    }

                    > div:nth-of-type(1):hover {
                        transform: translate(0, -8px)
                    }

                    .foot-btn {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 10px;

                        > div {
                            background: #2BC3B9;
                            color: #FFFFFF;
                            font-size: 15px;
                            text-align: center;
                            cursor: pointer;
                            transition: all .3s;
                            padding: 4px 8px;
                            border-radius: 4px;
                            flex: 1;
                            margin: 0 3px;
                        }

                        > div:hover {
                            opacity: .8;
                        }

                        .red-btn {
                            background: #FA4860;
                        }
                    }
                }

                .not-data {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    color: #000;
                }
            }
        }

        .foot-info {
            margin-top: 10px;
            font-size: 14px;
            color: #333;

            span {
                color: #fa4860;
                padding: 0 10px;
            }
        }
    }
</style>